import React, { useState, useEffect } from 'react';

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    // Appear sooner
    if (window.pageYOffset > 100) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Set up event listener and check on mount
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    toggleVisibility(); // Set initial state
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  // Scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
   <button
  onClick={scrollToTop}
  className={`fixed bottom-6 right-6 z-50 rounded-full p-3 border-2 border-green-500 bg-white/20 backdrop-blur-md text-green-700 shadow-xl hover:shadow-2xl transition-transform duration-300 transform hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-green-400 ${
    isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
  }`}
  aria-label="Scroll to top"
  disabled={!isVisible}
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6 animate-pulse"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
  </svg>
</button>

  );
};

export default ScrollToTopButton;